import { render, staticRenderFns } from "./OnboardingComponent.vue?vue&type=template&id=97defaba&scoped=true"
import script from "./OnboardingComponent.vue?vue&type=script&lang=js"
export * from "./OnboardingComponent.vue?vue&type=script&lang=js"
import style0 from "./OnboardingComponent.vue?vue&type=style&index=0&id=97defaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97defaba",
  null
  
)

export default component.exports